export function requireWechatCodeUrl(value) {
  if (typeof value !== 'string' || !value.trim().startsWith('weixin://wxpay/bizpayurl?')) {
    throw new Error('微信支付码获取失败，请刷新重试或联系客服')
  }
  return value.trim()
}

export function reserveAlipayWindow() {
  const paymentWindow = window.open('about:blank', '_blank')
  if (!paymentWindow) throw new Error('请允许此网站打开支付窗口后重试')
  paymentWindow.opener = null
  return paymentWindow
}

export function navigateAlipayWindow(paymentWindow, value) {
  let url
  try { url = new URL(value) } catch (error) { throw new Error('支付宝支付地址获取失败，请重试') }
  if (url.protocol !== 'https:' || !['openapi.alipay.com', 'openapi-sandbox.dl.alipaydev.com', 'openapi.alipaydev.com'].includes(url.hostname)
      || url.pathname !== '/gateway.do' || url.username || url.password) {
    throw new Error('支付宝支付地址异常，请联系客服')
  }
  if (!paymentWindow || paymentWindow.closed) throw new Error('支付窗口已关闭，请重新发起支付')
  paymentWindow.location.replace(url.href)
}
